import { z } from 'zod';

import { UuidSchema } from '../../common/id/id';

/**
 * Blocking a member.
 *
 * **One field**, and no reason code. A block is not a report and must never feel
 * like filing one: the member is choosing not to be reachable, and asking them
 * to categorise the person they are getting away from is a question they do not
 * owe anybody. Reporting is a separate, deliberate act on the same sheet.
 *
 * There is no `unblock` body — that route names its target in the path — and no
 * timestamp: the clock is the server's (N3).
 */
export const BlockCreateSchema = z
  .object({
    blockedUserId: UuidSchema,
  })
  .strict();

export type BlockCreateRequest = z.infer<typeof BlockCreateSchema>;
